<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{$t('receive_sms_if_applicable') }} ?</label>
          <input
            class="form-control"
            type="notification_phone_number"
            name="notification_phone_number"
            v-model="model.notification_phone_number"
            :placeholder="$t('enter_only_if_you_want_sms')"
          />
          <small>{{ $t('notifications_optional') }}!</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{ $t('create_password') }}</label>
          <div class="input-group">
          <input
            class="form-control"
            ref="password"
            :type="passwordFieldType"
            name="password"
            v-validate="'required|min:5'"
            v-model="model.password"
            :placeholder="$t('create_password_remember')"
          /><div class="input-group-btn">
            <span @click="togglePassVisible()" class="btn btn-sm" >
              <i class="glyphicon glyphicon-eye-open"></i>
            </span>
          </div>
          </div>
          <small class="text-danger" v-show="password.invalid">{{ getError('password') }}</small>        
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{ $t('repeat') }}</label>
          <input
            class="form-control"
            v-model="model.passwordRepeat"
            type="password"
            name="passwordRepeat"
            v-validate="'required|confirmed:password'"
            :placeholder="$t('create_password_remember')"
          />
          <small
            class="text-danger"
            v-show="passwordRepeat.invalid"
          >{{ getError('passwordRepeat') }}</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label" ><a href="/static/terms-conditions.pdf" target="_blank">{{ $t('agree_terms_conditions') }}</a></label>
          <br />
          <p-switch
            v-model="model.agreeTermsConditions"
            v-validate="'required'"
            toggle="false"
            name="agreeTermsConditions"
            type="primary"
            value="true"
            on-text="YES"
            off-text="NO"
          >
            <span slot="hover-label">{{ $t('you_need_to_agree') }}!</span>
          </p-switch>
          <small
            class="text-danger"
            v-show="agreeTermsConditions.invalid"
          >{{ getError('agreeTermsConditions') }}</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{ $t('id_like_newsletters') }}</label>
          <br />
          <p-switch
            v-model="model.newsletter"
            toggle="false"
            name="newsletter"
            type="primary"
            value="true"
            on-text="YES"
            off-text="NO"
          ></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vee-validate";
import PSwitch from "src/components/UIComponents/Switch.vue";
import swal from "sweetalert2";
export default {
  components: {
    PSwitch
  },
  computed: {
    ...mapFields([
      "notification_phone_number",
      "password",
      "passwordRepeat",
      "agreeTermsConditions",
      "newsletter"
    ])
  },
  data() {
    return {
      passwordFieldType: 'password',
      termsConditionsData: "",
      model: {
        notification_phone_number: "",
        password: "",
        passwordRepeat: "",
        agreeTermsConditions: false,
        newsletter: false
      }
    };
  },
  methods: {
    togglePassVisible() {
      this.passwordFieldType = this.passwordFieldType  == 'password' ? 'text' : 'password';
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    getTerms() {
      let terms = Webservice.getTermsConditions()
        .then(resp => {
          if (resp.data) {
            swal({
              html: resp.data,
              width: 800
            });
          }
        })
        .catch(error => {
          this.$notify({
            component: {
              template: `<span>An error occured while retrieving the terms and conditions. Please contact us via email or other means</span>`
            },
            icon: "ti-info",
            type: "error"
          });
        });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register/FinalStep.vue